<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
          <div slot="no-body" class="full-page-bg-color pb-10" v-if="this.$route.params.code">
              <div class="vx-row no-gutter">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Verify your account</h4>
                  <p class="text-justify">To help protect you from abuse, we will sometimes ask you to prove you’re not a robot before you can create or sign in to your account.</p>
                </div>
                <vs-input
                  data-vv-validate-on="blur"
                  v-validate="'required|min:8'"
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  @keyup.enter="verifyCation"
                  class="w-full mt-6" />
                <vs-button type="filled" to="/pages/login" class="mt-5" @click="verifyCation">Login</vs-button>
              </div>
            </div>
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/verify.svg" alt="register" class="mx-auto">
            </div>
          </div>
          </div>
          <div slot="no-body" class="full-page-bg-color py-2" v-else>

              <div class="vx-row no-gutter justify-center items-center">
                <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                  <div class="px-8 pt-8 login-tabs-container">

                    <div class="vx-card__title ">
                      <h4 class="mb-4">Login</h4>
                      <p>Welcome back! Please log into your account.</p>
                    </div>

                    <div class="loginLexi">
                      <login-firebase></login-firebase>
                    </div>

                  </div>
                </div>
                <div class="vx-col hidden lg:block lg:w-1/2">
                  <img src="@/assets/images/pages/login.svg" alt="login" class="mx-auto w-4/5	">
                </div>
              </div>
          </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginFirebase from './LoginFirebase.vue'
import axios from "@/axios";

export default {
  components: {
    LoginFirebase,
  },
  data(){
    return{
      password: null
    }
  },
  methods:{
    async verifyCation(){
        try{
          this.$vs.loading();
          const {data} = await axios.post('/account/verify/',{code: this.$route.params.code,password: this.password })
          this.$store.commit('auth/getToken',data.token)
          this.$store.commit('auth/getUserDetail',data.user)
          this.$router.push('/contacts').then(()=>{})
        }catch (e){
          throw e
        }finally {
          this.$vs.loading.close();
        }
    }
  },
  mounted() {
      if(localStorage.getItem('accessToken')){
        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')
      }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.loginLexi{
  position: relative;
  top: 1em;
}
</style>
